module.exports = "https://s.pinimg.com/webapp/style/images/bg_audience_half-fdca220b.png";